// extracted by mini-css-extract-plugin
export default {"loading":"SvgIcon_loading__yi+7H"};